import { PURCHASER_API_BASE_URL, getHeaders } from "../Constants";

function sendEventRequest(event: string, properties: Record<string, unknown>): Promise<Response> {
    return fetch(`${PURCHASER_API_BASE_URL}/ingest/events`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({
            event,
            properties,
        }),
    });
}

export default {
    sendRequestContactForVendorEvent: async (vendorUniquePublicIdId: string, vendorName: string): Promise<void> => {
        const response = await sendEventRequest("Request Contact For Vendor", {
            vendorUniquePublicIdId,
            vendorName,
        });

        if (!response.ok) {
            throw new Error("Failed to send request contact for vendor event");
        }
    },
};
